<template>
  <v-card
    tile
    height="100%"
  >
    <v-toolbar
      color="primaryLight"
      dark
      dense
      style="z-index: 2"
    >
      <v-toolbar-title>Gestión de medios</v-toolbar-title>

      <v-tooltip
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            v-bind="attrs"
            :disabled="disabledByRol"
            fab
            small
            bottom
            right
            absolute
            color="secondary"
            v-on="on"
            @click="showAddMedioDialog"
          >
            <v-icon
              color="primary"
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </template>
        <span>Añadir medio</span>
      </v-tooltip>
      <v-tooltip
        bottom
      >
        <template
          #activator="{ on, attrs }"
        >
          <v-btn
            fab
            small
            bottom
            right
            absolute
            color="secondary"
            v-bind="attrs"
            style="margin-right: 3rem;"
            v-on="on"
            @click="exportarMediosPDF()"
          >
            <v-icon
              color="primary"
            >
              mdi-file-pdf-box
            </v-icon>
          </v-btn>
        </template>
        <span>Exportar PDF</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-container
        ref="firstContainer"
        class="py-0 ma-0"
        fluid
      >
        <!-- Primera fila -->
        <v-row
          align="center"
          class="no-spacing-row"
        >
          <!-- Filtro para los campos de la tabla -->
          <v-col
            cols="10"
          >
            <v-autocomplete
              v-model="tableFilters"
              return-object
              :items="headers.filter(x => x.text !== 'Acciones')"
              :items-text="(h) => { return h.text }"
              item-title="text"
              label="Mostrar campos"
              multiple
              clearable
              dense
              outlined
            >
              <template
                #selection="{ item, index }"
              >
                <v-chip
                  v-if="index < maxVisible"
                  :key="item.value"
                  small
                >
                  {{ item.text }}
                </v-chip>
                <span
                  v-else-if="index === maxVisible"
                  :key="index"
                  small
                >
                  {{ computedHeaders.length - maxVisible - 1 }} más
                </span>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col
            cols="1"
          >
            <v-btn
              icon
              color="teal"
              @click="resetFilters()"
            >
              <v-icon>mdi-cached</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row
          align="center"
        >
          <v-col
            sm="3"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Búsqueda general"
              outlined
              clearable
              hide-details
            />
          </v-col>
          <v-col
            cols="1"
          >
            <v-text-field
              v-model="medioSelected"
              label="Medio"
            />
          </v-col>
          <v-col
            cols="1"
          >
            <v-text-field
              v-model="tipoSelected"
              label="Tipo"
            />
          </v-col>
          <!-- <v-col cols="1">
            <v-text-field label="Categoría" v-model="categoriaSelected" />
          </v-col> -->
          <v-col
            cols="1"
          >
            <v-text-field
              v-model="nombreSelected"
              label="Indicativo"
            />
          </v-col>
          <!-- <v-col cols="1">
            <v-text-field label="Fecha ult. posición" v-model="fechaUltPosicionSelected" hint="DD/MM/YYYY" style="min-width: max-content;" />
          </v-col> -->
        </v-row>
      </v-container>
      <v-container
        ref="secondContainer"
        fluid
      >
        <v-row>
          <v-data-table
            class="table"
            :headers="computedHeaders"
            :items="mediosFilter"
            :search="search"
            fixed-header
            disable-pagination
            hide-default-footer
            :style="{ height: `calc(${availableSpace}vh)` }"
          >
            <!-- :items-per-page="30" -->
            <template
              #no-data
            >
              <p>Datos no disponibles.</p>
            </template>

            <template
              #[`item.DISPOSITIVO`]="{ item }"
            >
              <span>{{ item.DISPOSITIVO }}</span>
            </template>

            <template
              #[`item.SERVICIO`]="{ item }"
            >
              <span>{{ item.SERVICIO }}</span>
            </template>

            <template
              #[`item.TELEFONO_INTERNO`]="{ item }"
            >
              <span>{{ item.TELEFONO_INTERNO }}</span>
            </template>

            <template
              #[`item.TELEFONO_EXTERNO`]="{ item }"
            >
              <a
                :href="'tel:+34' + item.TELEFONO_EXTERNO"
              >{{
                item.TELEFONO_EXTERNO
              }}</a>
            </template>

            <template
              #[`item.TIEMPO_OPERATIVO`]="{ item }"
            >
              {{ formatDuracion(item.TIEMPO_OPERATIVO) }}
            </template>

            <template
              #[`item.TIEMPO_TRABAJO`]="{ item }"
            >
              {{ formatDuracion(item.TIEMPO_TRABAJO) }}
            </template>

            <template
              #[`item.TIEMPO_DESCANSO`]="{ item }"
            >
              {{ formatDuracion(item.TIEMPO_DESCANSO) }}
            </template>

            <template
              #[`item.ACCIONES`]="{ item }"
            >
              <v-tooltip
                bottom
              >
                <template
                  #activator="{ on, attrs }"
                >
                  <v-btn
                    v-bind="attrs"
                    :disabled="disabledByRol"
                    icon
                    v-on="on"
                    @click="showEditMedioDialog(item)"
                  >
                    <v-icon
                      color="teal"
                    >
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip
                bottom
              >
                <template
                  #activator="{ on, attrs }"
                >
                  <v-btn
                    v-bind="attrs"
                    :disabled="disabledByRol"
                    icon
                    v-on="on"
                    @click="acceptDeleteMedio(item)"
                  >
                    <v-icon
                      color="error"
                    >
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </template>
                <span>Borrar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-row>
      </v-container>
    </v-card-text>

    <vx-dialog-add-edit-medio
      :show="showDialog"
      :is-edit="isEdit"
      :edited-medio="editMedio"
      @cancelar="showDialog = false"
      @addMedio="acceptAddMedio"
      @editMedio="acceptEditMedio"
    />
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import DialogAddEditMedio from './DialogAddEditMedio'

import constants from '../../helpers/constants'
import { normalizeText } from '@/helpers/Utils.js'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.vfs

export default {
  components: {
    'vx-dialog-add-edit-medio': DialogAddEditMedio
  },

  data: () => ({
    headers: [
      { text: 'Dispositivo', value: 'DISPOSITIVO', align: 'left', sortable: true, initialShow: true },
      { text: 'Servicio', value: 'SERVICIO', align: 'left', sortable: true, initialShow: true },
      { text: 'Tipo de medio', value: 'TIPO', align: 'left', sortable: true, initialShow: true },
      { text: 'Medio', value: 'MEDIO', align: 'left', sortable: true, initialShow: true },
      { text: 'Indicativo', value: 'NOMBRE', align: 'left', sortable: true, initialShow: true },
      { text: 'Base', value: 'INFRAESTRUCTURA', align: 'left', initialShow: true },
      { text: 'Periodo operatividad', value: 'TIEMPO_OPERATIVO', align: 'left', initialShow: true },
      { text: 'Hora entrada', value: 'HORA_ENTRADA', align: 'left', initialShow: true },
      { text: 'Hora salida', value: 'HORA_SALIDA', align: 'left', initialShow: true },
      { text: 'Tiempo trabajo incendio', value: 'TIEMPO_TRABAJO', align: 'left', initialShow: true },
      { text: 'Tiempo descanso obligado', value: 'TIEMPO_DESCANSO', align: 'left', initialShow: true },
      { text: 'Tel. interno', value: 'TELEFONO_INTERNO', align: 'left', sortable: false, initialShow: true },
      { text: 'Tel. externo', value: 'TELEFONO_EXTERNO', align: 'left', sortable: false, initialShow: true },
      { text: 'Acciones', value: 'ACCIONES', align: 'center', width: '10%', sortable: false, initialShow: true }
    ],
    tableFilters: [],
    maxVisible: 8,
    showDialog: false,

    medioSelected: '',
    tipoSelected: '',
    categoriaSelected: '',
    nombreSelected: '',
    fechaUltPosicionSelected: '',
    activoSelected: true,
    mediosFilter: [],

    search: '',
    editMedio: {},
    isEdit: false,
    availableSpace: 0

  }),

  computed: {
    medios() {
      return this.$store.getters['medio/medios']
    },

    disabledByRol() {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    },

    computedHeaders() {
      return this.headers.filter(x => (this.tableFilters.length > 0 && x.text === 'Acciones') || this.tableFilters.includes(x))
    }
  },

  watch: {
    medios() {
      this.filterMedios()
    },
    medioSelected() {
      this.filterMedios()
    },
    tipoSelected() {
      this.filterMedios()
    },
    categoriaSelected() {
      this.filterMedios()
    },
    nombreSelected() {
      this.filterMedios()
    },
    fechaUltPosicionSelected() {
      this.filterMedios()
    },
    activoSelected() {
      this.filterMedios()
    }

  },

  mounted() {
    this.filterMedios()
    // Calcular el espacio disponible al montar el componente
    this.calculateAvailableSpace()
    // Resetear filtros
    this.resetFilters()
    // También puedes actualizar el espacio disponible si la ventana se redimensiona
    window.addEventListener('resize', this.calculateAvailableSpace)
  },

  beforeDestroy() {
    // Limpiar el event listener para evitar fugas de memoria
    window.removeEventListener('resize', this.calculateAvailableSpace)
  },

  methods: {
    ...mapActions('medio', ['addMedio', 'updateMedio', 'deleteMedio']),

    showAddMedioDialog() {
      this.editMedio = null
      this.showDialog = true
      this.isEdit = false
    },

    showEditMedioDialog(item) {
      this.editMedio = Object.assign({}, item)
      this.showDialog = true
      this.isEdit = true
    },

    acceptDeleteMedio(medio) {
      const msg = `Eliminando el medio: ${medio.MEDIO}`
      this.$root.$confirmDialog.open('¿Está seguro?', msg).then((result) => {
        if (result) {
          this.$store.dispatch('medio/deleteMedio', medio)
        }
      })
    },

    acceptAddMedio(medio) {
      this.showDialog = false
      this.addMedio(medio)
    },

    acceptEditMedio(medio) {
      this.showDialog = false
      this.updateMedio(medio)
    },

    formatDuracion(minutos) {
      if (!minutos) {
        return ''
      }

      const dias = Math.floor(minutos / 1440)
      const horas = Math.floor((minutos % 1440) / 60)
      const mins = minutos % 60

      const partes = []

      if (dias > 0) {
        partes.push(`${dias}d`)
      }

      if (horas > 0) {
        partes.push(`${horas}h`)
      }

      if (mins > 0) {
        partes.push(`${mins}m`)
      }

      return partes.length ? partes.join(' ') : '0m'
    },

    exportarMediosPDF() {
      // Exporta medios terrestres y fechas a un PDF
      const bodyPdf = []
      bodyPdf.push(['Medio', 'Tipo', 'Fecha'])

      const mediosFechaOk = this.medios.filter((x) =>
        this.$date.parseDate(x.FECHA).isValid()
      )
      const mediosFechaMal = this.medios.filter(
        (x) => !this.$date.parseDate(x.FECHA).isValid()
      )

      const mediosOrdenados = mediosFechaOk.sort((a, b) => {
        const aOrden = this.$date.parseDate(a.FECHA)
        const bOrden = this.$date.parseDate(b.FECHA)

        return bOrden > aOrden ? 1 : -1
      })

      for (let i = 0; i < mediosFechaMal.length; i++) {
        mediosOrdenados.push(mediosFechaMal[i])
      }

      for (let i = 0; i < mediosOrdenados.length; i++) {
        const medio = mediosOrdenados[i]

        const datosMedio = []
        datosMedio.push({ text: medio.MEDIO, bold: true })
        datosMedio.push(medio.TIPO)
        datosMedio.push(this.$date.formatDate(medio.FECHA, 'DD/MM/YYYY HH:mm'))
        bodyPdf.push(datosMedio)
      }

      const docDefinition = {
        content: [],
        defaultStyle: {
          fontSize: 9
        }
      }

      docDefinition.content.push(constants.headerPDF)

      docDefinition.content.push(
        {
          text: [
            { text: 'Fecha/hora informe: ', bold: true },
            this.$date.currentDate()
          ],
          margin: [0, 0, 0, 15]
        },
        {
          layout: 'lightHorizontalLines', // optional
          table: {
            headerRows: 1,
            body: bodyPdf
          },
          margin: [0, 15, 0, 20]
        }
      )

      pdfMake
        .createPdf(docDefinition)
        .download(
          `Medios_Fecha_${this.$date.now().format('YYYY_MM_DD_hh_mm')}`
        )
    },
    async filterMedios() {
      let mediosFilter = []
      if (this.medios) {
        mediosFilter = [...this.medios]

        if (this.medioSelected !== null && this.medioSelected !== '') {
          mediosFilter = mediosFilter.filter(x => x.MEDIO.includes(this.medioSelected))
        }

        if (this.tipoSelected !== null && this.tipoSelected !== '') {
          mediosFilter = mediosFilter.filter(x => x.TIPO && normalizeText(x.TIPO).includes(normalizeText(this.tipoSelected)))
        }

        if (this.categoriaSelected !== null && this.categoriaSelected !== '') {
          mediosFilter = mediosFilter.filter(x => x.CATEGORIA.includes(this.categoriaSelected))
        }

        if (this.nombreSelected !== null && this.nombreSelected !== '') {
          mediosFilter = mediosFilter.filter(x => x.NOMBRE && x.NOMBRE.toLowerCase().includes(this.nombreSelected.toLowerCase()))
        }

        if (this.fechaUltPosicionSelected !== null && this.fechaUltPosicionSelected !== '') {
          mediosFilter = mediosFilter.filter(x => {
            // Verificar si la fecha en ULT_POSICION es válida
            if (x.ULT_POSICION && x.ULT_POSICION.FECHA) {
              return this.$date.formatDate(x.ULT_POSICION.FECHA, 'DD/MM/YYYY HH:mm').includes(this.fechaUltPosicionSelected)
            } else {
              return false
            }
          })
        }

        mediosFilter.sort((a, b) => {
          if (!a.MEDIO) return 1
          if (!b.MEDIO) return -1
          return a.MEDIO.localeCompare(b.MEDIO)
        })

        this.mediosFilter = mediosFilter
      } else {
        await new Promise((resolve, reject) => setTimeout(resolve, 500))
        this.filterMedios()
      }
    },

    increaseFirstContainerHeight() {
      // Forzar una actualización del DOM para reflejar la nueva altura
      this.$nextTick(() => {
        this.calculateAvailableSpace()
      })
    },
    calculateAvailableSpace() {
      // Obtener la posición y altura del primer v-container
      const firstContainer = this.$refs.firstContainer
      const firstContainerRect = firstContainer.getBoundingClientRect()
      const firstContainerBottom = firstContainerRect.top + firstContainerRect.height

      // Obtener la altura del viewport
      const viewportHeight = window.innerHeight

      // Calcular el espacio disponible en vh
      this.availableSpace = ((viewportHeight - firstContainerBottom) / viewportHeight) * 100
    },

    resetFilters() {
      this.tableFilters = this.headers.filter(x => x.initialShow)
    }

  }

}
</script>

<style scoped>
/* Estilos para que la tabla tenga un max-height y pueda crecer */
.table {
  width: 100vw;
}

.v-data-table {
  overflow: auto;
}
.v-data-table >>> .v-data-table__wrapper {
  /* Header fijo */
  overflow: unset;
}
</style>
